var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { getCurrentPermissions } from '../Authentication/AuthorisationAsync';
import { AuthState } from '../Authentication/AuthorisationModels';
import { getMedicationsPermissions, setMedicationsPermissions } from '../Config/PermissionConfig';
export function isUserAuthorised(code) {
    if (Array.isArray(code)) {
        var isAuthorised_1 = true;
        code.forEach(function (targetCode) {
            var permissionState = getMedicationsPermissions().find(function (it) { return it.definitionCode === targetCode; });
            if (permissionState) {
                if (permissionState.state !== AuthState.Allowed)
                    isAuthorised_1 = false;
            }
            else {
                isAuthorised_1 = false;
                console.warn('Unknown permission code requested - code: ', code);
            }
        });
        return isAuthorised_1;
    }
    else {
        var permissionState = getMedicationsPermissions().find(function (it) { return it.definitionCode === code; });
        if (permissionState)
            return permissionState.state === AuthState.Allowed;
    }
    console.warn('Unknown permission code requested - code: ', code);
    return false;
}
export var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus["Loading"] = "Loading";
    LoadingStatus["Loaded"] = "Loaded";
    LoadingStatus["Error"] = "Error";
})(LoadingStatus || (LoadingStatus = {}));
export function usePermissionLoader() {
    var _a = __read(useState(LoadingStatus.Loading), 2), permissionStatus = _a[0], setPermissionStatus = _a[1];
    function loadPermissions() {
        return __awaiter(this, void 0, void 0, function () {
            var permissions, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getCurrentPermissions()];
                    case 1:
                        permissions = _a.sent();
                        setMedicationsPermissions(permissions);
                        setPermissionStatus(LoadingStatus.Loaded);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        setPermissionStatus(LoadingStatus.Error);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return {
        permissionStatus: permissionStatus,
        loadPermissions: loadPermissions
    };
}
